// config
import axios, { handleResp, setAuthorization, removeAuthorization } from '../config/axios';
// reducers
import { setAuthAccount, removeAuthAccount } from '../redux/reducers/auth';
// import lib
import { decodeJWT } from '../lib/auth';

export const setAuthRedux = (dispatch, token) => {
    try {
        const { status, decoded, message } = decodeJWT(token);
        if (!status) return { status, message };
        setAuthorization(token);
        dispatch(setAuthAccount(decoded));
        return { status: true };
    } catch (error) {
        console.log(error, 'errorerror')
        return { status: false, message: 'Error on store process' };
    }
}

export const logout = (dispatch) => {
    try {
        removeAuthorization()
        dispatch(removeAuthAccount())
        return true;
    } catch (error) {
        console.log(error, 'errorerror')
        return false;
    }
}

export const register = async (data) => {
    try {

        let respData = await axios({
            url: `/user/register`,
            method: 'post',
            data,
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const createContact = async (data) => {
    try {

        let respData = await axios({
            url: `/user/contact`,
            method: 'post',
            data,
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const login = async (data, dispatch) => {
    try {
        let respData = await axios({
            url: `/user/login`,
            method: 'post',
            data,
        });

        const { status, message } = setAuthRedux(dispatch, respData?.data?.token)
        if (!status) return { status, message };
        return handleResp(respData);

    } catch (err) {
        return handleResp(err.response);
    }
};